<template>
  <ValidationProvider name="Ad Account" slim vid="facebook_ad_account_id" rules="required">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="ad_account_id"> Ad Account </BaseFormLabel>
        <VSelect
          id="ad_account_id"
          v-model="adAccountId"
          :options="adAccountOptions"
          label="name"
          :reduce="(adAccount) => adAccount.id"
          :disabled="disabled"
          class="vue-select custom-option"
        >
          <template #option="{ id, name }">
            <div class="group px-4 py-2">
              <p class="text-sm font-medium text-gray-900 group-hover:text-white">
                {{ name }}
              </p>
              <span class="text-gray-400 group-hover:text-indigo-200 text-xs">{{ id }}</span>
            </div>
          </template>
        </VSelect>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
import { facebookAdAccountsClient } from '@/api/clients';

export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: Boolean,
  },
  data() {
    return {
      adAccountOptions: [],
    };
  },
  computed: {
    adAccountId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.fetchAdAccounts();
  },
  methods: {
    async fetchAdAccounts(query = {}) {
      try {
        const response = await facebookAdAccountsClient.list(query);

        this.setAdAccountOptions(response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setAdAccountOptions(adAccounts) {
      this.adAccountOptions = adAccounts;
    },
  },
};
</script>
